import React from 'react';
import SiteFooterView from './SiteFooterView';

function SiteFooter(props) {
  return <SiteFooterView {...props} />;
}

export default SiteFooter;
